// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"64d656ca","45":"1541e37e","64":"874f6fb0","184":"8726ac09","207":"9fea1660","237":"faf93163","307":"9ba93371","403":"f71e806b","453":"453f2ef2","485":"da3f7545","631":"550949ba","640":"03de18c1","661":"a4b35f78","704":"66792851","950":"ae692250","994":"29313b8c"}[chunkId] + ".chunk.js";
};